export const tagsByModuleApi = '/api/v1/common/tag/by_module/';